import React from "react";
import {
  Switch,
  Route,
  useRouteMatch
} from "react-router-dom";

// reactstrap components
import {
  Container
} from "reactstrap";

// core components
import MainNavbar from "components/Navbars/MainNavbar.js";
import LandingPageHeader from "components/Headers/LandingPageHeader.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";
import SEO from "components/SEO/SEO.js";
import {
  DogListingGrid,
  useLandingPageClasses
} from "components/Dogs/DogComponents.js";
import GambitPage from "./GambitPage";
import CirillaPage from "./CirillaPage";
import VenusPage from "./VenusPage";
import NimonaPage from "./NimonaPage";
import SqueezePage from "./SqueezePage";
import SeekerPage from "./SeekerPage";
import RumiPage from "./RumiPage";

const breedingDogs = [
  {
    name: "Rumi",
    href: "/dogs/rumi",
    image: require("../../assets/img/dogs/profile-rumi.jpg"),
    breed: "Sport Mix"
  },
  {
    name: "Squeeze",
    href: "/dogs/squeeze",
    image: require("../../assets/img/dogs/profile-squeeze.jpg"),
    breed: "Border Collie",
    status: "co-owned"
  },
  {
    name: "Seeker",
    href: "/dogs/seeker",
    image: require("../../assets/img/dogs/profile-seeker.jpg"),
    breed: "Border Collie",
    status: "for stud"
  },
  {
    name: "Venus",
    href: "/dogs/venus",
    image: require("../../assets/img/dogs/profile-venus2.jpg"),
    breed: "Border Collie"
  }
];

const retiredDogs = [
  {
    name: "Nimona",
    href: "/dogs/nimona",
    image: require("../../assets/img/dogs/profile-nimona.jpg"),
    breed: "Sport Mix"
  },
  {
    name: "Cirilla",
    href: "/dogs/cirilla",
    image: require("../../assets/img/dogs/profile-ciri2.jpg"),
    breed: "Border Collie",
    status: "not-bred"
  },
  {
    name: "Gambit",
    href: "/dogs/gambit",
    image: require("../../assets/img/dogs/profile-gambit2.jpg"),
    breed: "Border Collie",
    status: "not-bred"
  }
];

function PageSectionHeading({ eyebrow, title, children }) {
  return (
    <div className="index-section-heading">
      {eyebrow && <p className="about-eyebrow">{eyebrow}</p>}
      <h2>{title}</h2>
      <span aria-hidden="true"></span>
      {children}
    </div>
  );
}

function DogsPage() {
  let { path } = useRouteMatch();
  useLandingPageClasses();

  return (
    <>
      <Switch>
        <Route exact path={path}>
          <SEO
            title="Our Dogs | Border Collies & Sport Mixes"
            description="Meet the Endgame Sport Dogs border collies and sport mixes near Raleigh NC, including breeding, co-owned, retired, and non-breeding dogs competing in agility, flyball, dock diving, disc, herding, and more."
            path="/dogs"
          />
          <MainNavbar />
          <div className="wrapper dogs-index-page site-bg-light-grey">
            <LandingPageHeader
              bg="header6"
              hideText
              title="Endgame Border Collies & Sport Mixes"
              subtitle="Meet the Border Collies and sport mixes behind Endgame Sport Dogs."
            />
            <main className="index-page-main site-bg-light-grey">
              <Container>
                <section className="listing-section">
                  <PageSectionHeading eyebrow="Potential Parents" title="Breeding Dogs & Co-owns" />
                  <DogListingGrid
                    dogs={breedingDogs}
                    rowClassName="dog-portfolio-grid"
                    cardClassName="dog-portfolio-card"
                  />
                </section>

                <section className="listing-section listing-section-alt">
                  <PageSectionHeading eyebrow="Legacy Dogs" title="Retired Breeding & Non-breeding" />
                  <DogListingGrid
                    dogs={retiredDogs}
                    rowClassName="dog-portfolio-grid"
                    cardClassName="dog-portfolio-card"
                  />
                </section>
              </Container>
            </main>
            <DefaultFooter />
          </div>
        </Route>
        <Route path={`${path}/gambit`}>
          <GambitPage />
        </Route>
        <Route path={`${path}/cirilla`}>
          <CirillaPage />
        </Route>
        <Route path={`${path}/venus`}>
          <VenusPage />
        </Route>
        <Route path={`${path}/nimona`}>
          <NimonaPage />
        </Route>
        <Route path={`${path}/squeeze`}>
          <SqueezePage />
        </Route>
        <Route path={`${path}/seeker`}>
          <SeekerPage />
        </Route>
        <Route path={`${path}/rumi`}>
          <RumiPage />
        </Route>
      </Switch>
    </>
  );
}

export default DogsPage;
